import React, { useState } from "react";
// ROUTER
import { withRouter } from "../../utils/withRouter";
// CANVAS
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Margin from "canvas-core-react/lib/Margin";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import Row from "canvas-core-react/lib/Row";

// IMGS
import evertec from "../../components/img/evertec.png";

// COMPONENTS
import Layout from "../../components/Layout/Layout";
import Foot from "../../components/Layout/Foot";

import { ReactComponent as icon } from '../../components/icons/icon_payment.svg';
import DefaultError from "../icons/DefaultError";
import BrandLine from "../BrandLine";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";

// STYLES
// import "./style.scss";


const RetryError = ({ navigate }) => {

	const [showPayment, setShowPayment] = useState(true);


	return (
		<>
			<>
				<Layout idBlackBanner={0} showBanner={true}>
					{/* BANNER */}
					<Column lg={12} lgOffset={0}>
						<Margin side="top" lg={24} />
						<Row justifyContent="center" style={{ textAlign: 'center' }}>
							<Column
								xs={4}
								sm={8}
								md={9}
								lg={9}
							>
								<Margin side="top" xs={90} sm={60} md={60} lg={60}>
									<DefaultError />
								</Margin>
								<Margin side="top" xs={0} sm={24} md={24} lg={24}>
									<TextSubtitle type="1" component="h3">
										¡Vaya!
									</TextSubtitle>
									<TextSubtitle type="1" component="h3">
										Hubo un inconveniente
									</TextSubtitle>
								</Margin>
								<Margin side="top" xs={12} sm={24} md={24} lg={24}>
									<BrandLine />
								</Margin>
								<Margin xs={18} sm={36} md={36} lg={36}>
									<TextBody component="p">
										Los datos ingresados no cumplen con los requisitos necesarios para invertir en Scotiabank.
									</TextBody>
								</Margin>
								<PrimaryButton
									id={'buttonId'}
									labelPadding={36}
									style={{width:'200px'}}
									onClick={() => navigate("/")}
								>
									Volver
								</PrimaryButton>
							</Column>
						</Row>
					</Column>
				</Layout>
				<Foot />
			</>

		</>
	);
}

export default withRouter(RetryError);